export const PRODUCTS = [
  {
    slug: "vanilla-almond",
    number: "No. 01",
    name: "Vanilla Almond",
    image: "/images/vanilla-almond.jpg",
  },
  {
    slug: "chocolate",
    number: "No. 02",
    name: "Chocolate",
    image: "/images/chocolate.jpg",
  },
].map((p) => ({
  ...p,
  comingSoon: true,
  size: "100g",
  protein: "~25g",
  nutrition: "Full nutrition facts coming soon",
  description:
    "A premium, handcrafted protein bar made with real, recognizable ingredients. Bigger, softer and chewier than a traditional protein bar: each substantial 100g bar is packed with approximately 25g of protein.",
  variants: [],
}));

export const getProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);

export const money = (n) => `$${Number(n ?? 0).toFixed(2)}`;
